import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService, Roles } from '../auth';

export const rolesGuard = (allowedRoles: Roles[]): CanActivateFn => {
    return () => {
        const auth = inject(AuthService);

        if (auth.isLoggedIn()) {
            const userRoles = <Roles[]>auth.getRolesArray();

            const hasRequiredRole = userRoles.some(
                (role) => role === Roles.SysAdmin || allowedRoles.includes(role)
            );

            return hasRequiredRole;
        }

        return false;
    };
};
